var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _rect8, _path2, _rect9, _rect10, _rect11, _rect12, _path3, _rect13, _rect14, _rect15, _rect16, _path4, _rect17, _circle, _circle2, _rect18, _rect19;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEarnWeekly({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 84,
    viewBox: "0 0 83 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 83,
    height: 74,
    rx: 2.73536,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 34,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 34,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#FFDF03"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1304 38.0875C49.3737 37.8663 49.1304 37.6375 49.1304 37.2812C49.1304 36.8725 49.467 36.5875 50.0304 36.5875C50.6237 36.5875 50.8437 36.9062 50.8637 37.375H51.6004C51.577 36.73 51.227 36.1375 50.5304 35.9463V35.125H49.5304V35.935C48.8837 36.0925 48.3637 36.565 48.3637 37.2887C48.3637 38.155 49.0004 38.5862 49.9304 38.8375C50.7637 39.0625 50.9304 39.3925 50.9304 39.7413C50.9304 40 50.767 40.4125 50.0304 40.4125C49.3437 40.4125 49.0737 40.0675 49.037 39.625H48.3037C48.3437 40.4463 48.8904 40.9075 49.5304 41.0612V41.875H50.5304V41.0688C51.1804 40.93 51.697 40.5063 51.697 39.7375C51.697 38.6725 50.887 38.3088 50.1304 38.0875Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 34,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 56,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#FFDF03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1304 60.0875C49.3737 59.8663 49.1304 59.6375 49.1304 59.2812C49.1304 58.8725 49.467 58.5875 50.0304 58.5875C50.6237 58.5875 50.8437 58.9062 50.8637 59.375H51.6004C51.577 58.73 51.227 58.1375 50.5304 57.9463V57.125H49.5304V57.935C48.8837 58.0925 48.3637 58.565 48.3637 59.2887C48.3637 60.155 49.0004 60.5862 49.9304 60.8375C50.7637 61.0625 50.9304 61.3925 50.9304 61.7413C50.9304 62 50.767 62.4125 50.0304 62.4125C49.3437 62.4125 49.0737 62.0675 49.037 61.625H48.3037C48.3437 62.4463 48.8904 62.9075 49.5304 63.0612V63.875H50.5304V63.0688C51.1804 62.93 51.697 62.5063 51.697 61.7375C51.697 60.6725 50.887 60.3088 50.1304 60.0875Z",
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 56,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 45,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 45,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#FFDF03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1304 49.0875C49.3737 48.8663 49.1304 48.6375 49.1304 48.2812C49.1304 47.8725 49.467 47.5875 50.0304 47.5875C50.6237 47.5875 50.8437 47.9062 50.8637 48.375H51.6004C51.577 47.73 51.227 47.1375 50.5304 46.9463V46.125H49.5304V46.935C48.8837 47.0925 48.3637 47.565 48.3637 48.2887C48.3637 49.155 49.0004 49.5862 49.9304 49.8375C50.7637 50.0625 50.9304 50.3925 50.9304 50.7413C50.9304 51 50.767 51.4125 50.0304 51.4125C49.3437 51.4125 49.0737 51.0675 49.037 50.625H48.3037C48.3437 51.4463 48.8904 51.9075 49.5304 52.0612V52.875H50.5304V52.0688C51.1804 51.93 51.697 51.5063 51.697 50.7375C51.697 49.6725 50.887 49.3088 50.1304 49.0875Z",
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 45,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 67,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 67,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 67,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#FFDF03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1304 71.0875C49.3737 70.8663 49.1304 70.6375 49.1304 70.2812C49.1304 69.8725 49.467 69.5875 50.0304 69.5875C50.6237 69.5875 50.8437 69.9062 50.8637 70.375H51.6004C51.577 69.73 51.227 69.1375 50.5304 68.9463V68.125H49.5304V68.935C48.8837 69.0925 48.3637 69.565 48.3637 70.2887C48.3637 71.155 49.0004 71.5862 49.9304 71.8375C50.7637 72.0625 50.9304 72.3925 50.9304 72.7413C50.9304 73 50.767 73.4125 50.0304 73.4125C49.3437 73.4125 49.0737 73.0675 49.037 72.625H48.3037C48.3437 73.4463 48.8904 73.9075 49.5304 74.0612V74.875H50.5304V74.0688C51.1804 73.93 51.697 73.5063 51.697 72.7375C51.697 71.6725 50.887 71.3088 50.1304 71.0875Z",
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 67,
    width: 16,
    height: 9,
    rx: 1,
    fill: "#505050"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 22.5,
    r: 3.5,
    fill: "#FAFAFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 22.5,
    r: 3.5,
    fill: "#FAFAFA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 3,
    height: 24,
    rx: 1.5,
    fill: "#B6B0FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    width: 3,
    height: 24,
    rx: 1.5,
    fill: "#B6B0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnWeekly);
export default __webpack_public_path__ + "static/media/earn-weekly.890ec5e27ecb6fb4483db7141a02e267.svg";
export { ForwardRef as ReactComponent };